import React from 'react'
import styles from './NotificationsPage.scss'
import { NotificationsApp } from 'features/notifications/NotificationsList'
import { StandardLayout } from 'common/layouts/StandardLayout'
import { StandardWidthPage } from 'common/StandardWidthPage'
import { FormattedMessage as T } from 'react-intl'

export class NotificationsPage extends React.PureComponent {
  render () {
    return (
      <StandardLayout>
        <StandardWidthPage>
          <div className={styles.NotificationsPage}>
            <h1><T id='notificationsPage.all' defaultMessage='All Notifications' /></h1>
            <div className={styles.list}>
              <NotificationsApp />
            </div>
          </div>
        </StandardWidthPage>
      </StandardLayout>
    )
  }
}
